
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import Rectangle from "slotworks/utils/geom/rectangle";
import spineManager from "slotworks/graphics/spine/spine-manager";
import ExtendedSpine from 'slotworks/graphics/spine/spine';
import Point from "slotworks/utils/geom/point";


export default class SpineSymbolBehaviour extends AbstractSymbolBehaviour {

    public static ANIMATE_BEHIND: boolean = false;

    protected masterSymbol: string = "symbol_1_1";

    protected defaultAnimation: string;

    protected spine: ExtendedSpine;

    protected offset: Point;

    protected completeResolve: () => void;

    /**
     * Animates spine over top of the static sprite during a win
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAniamtion="win"] {string}
     */
    constructor(symbol: SymbolComponent) {
        super(symbol);
    }

    public static() {
        this.cleanUp();
    }

    public updateTransform(): void {
        super.updateTransform();
        if (this.spine) {
            const symbolTransform = this.symbol.getTransform();

            const globalPosition = Layers.MatrixContent.localToGlobal(symbolTransform);
            const localPosition = Layers.SymbolAnimations.globalToLocal(globalPosition);

            this.spine.x = localPosition.x + localPosition.width/2 + this.offset.x;
            this.spine.y = localPosition.y + localPosition.height/2 + this.offset.y;
        }
    }

    public land(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public win(...args: any[]): Contract<void> {
        return this.animate("win", true, false);
    }

    public cycle(...args: any[]): Contract<void> {
        return this.animate("win", true, false);
    }

    public highlight(...args: any[]): Contract<void> {
        return this.animate("win", true, false);
    }

    public anticipate(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    protected animate(animation: string, autoReset: boolean = false, loop: boolean = false, position: string = null, offset: Point = null) {

        // Resolve existing animations before starting a new one
        if (this.completeResolve) {
            this.completeResolve();
        }
        this.cleanUp();

        const spine = spineManager.createSpineSymbol(this.symbol.symbolId);

        if(!spine) {
            return Contract.empty();
        }
        this.spine = spine;
        const masterRect = Layers.MatrixContent.getPosition(this.masterSymbol);

        let animRect = position ? Layers.MatrixContent.getPosition(position) : null;

        if(offset) {
            this.offset = offset;
        } else if(animRect) {
            this.offset = new Point(
                animRect.x + animRect.width/2 - masterRect.x - masterRect.width/2,
                animRect.y + animRect.height/2 - masterRect.y - masterRect.height/2
            );
        } else {
            this.offset = new Point(0, 0);
        }
        
        if (!spine.hasAnimation(animation)) {
            return Contract.empty();
        }
        
        Layers.SymbolAnimations.container.addChild(spine as any);
        this.updateTransform();

        return new Contract<void>((resolve) => {
            this.completeResolve = () => resolve(null);

            // this.symbol.setVisible(false);
            spine.play(0, animation, loop);

            if(!loop) {
                spine.state.tracks[0].listener = {
                    complete: () => {
                        this.cleanSpine();

                        if (this.completeResolve) {
                            this.completeResolve();
                            this.completeResolve = null;
                        }
                    }
                }
            }
        });
    }

    protected cleanSpine() {
        if(this.spine) {
            if(this.spine.state.tracks && this.spine.state.tracks[0] && this.spine.state.tracks[0].listener) {
                this.spine.state.tracks[0].listener.complete = null;
            }
            this.spine.state.setEmptyAnimation(0, 0);
            
            this.spine.state.clearTracks();
            this.spine.state.tracks = [];
            this.spine.skeleton.setToSetupPose();
            
            this.symbol.setVisible(true);
            this.spine.visible = false;
            const spine = this.spine;
            this.spine = null;
            this.symbol.updateTransform();
            setTimeout(() => Layers.SymbolAnimations.container.removeChild(spine as any), 1);
        }
    }

    protected cleanUp() {        
        this.cleanSpine();

        this.completeResolve = null;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/spine-symbol-behaviour.ts